export const studentsSelector = (state: any) => state.students;
